/**
 * @generated SignedSource<<51466c7503425964b5ac64eba68b2d0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationEditPageContainer_Query$variables = {
  slug: string;
};
export type NotificationEditPageContainer_QueryVariables = NotificationEditPageContainer_Query$variables;
export type NotificationEditPageContainer_Query$data = {
  readonly notification: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"NotificationEditPage_notification">;
  } | null;
};
export type NotificationEditPageContainer_QueryResponse = NotificationEditPageContainer_Query$data;
export type NotificationEditPageContainer_Query = {
  variables: NotificationEditPageContainer_QueryVariables;
  response: NotificationEditPageContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationEditPageContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Notification",
        "kind": "LinkedField",
        "name": "notification",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NotificationEditPage_notification"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationEditPageContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Notification",
        "kind": "LinkedField",
        "name": "notification",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b079ddad0e1ece7fd0db5792d4a291c",
    "id": null,
    "metadata": {},
    "name": "NotificationEditPageContainer_Query",
    "operationKind": "query",
    "text": "query NotificationEditPageContainer_Query(\n  $slug: String!\n) {\n  notification(slug: $slug) {\n    id\n    ...NotificationEditPage_notification\n  }\n}\n\nfragment NotificationEditPage_notification on Notification {\n  id\n  title\n  body\n  category\n  publishedAt\n  slug\n}\n"
  }
};
})();

(node as any).hash = "49704eef62449890e81631d2fc1e56da";

export default node;
